import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';

export interface GoalTrackDTO {
  goalName: string;
  startDate: string;
  endDate: string;
  targetPerformance: number | null;
  actualPerformance: number | null;
  startValue: number | null;
  trackingValue: number | null;
  endValue: number | null;
  targetValue: number | null;
}

interface Params {
  clientId: number;
}

const fetchGoalTrack = async ({ clientId }: Params): Promise<GoalTrackDTO[]> => {
  return authFetch(
    urlWithParams('/Consumer/Goaltrack', {
      clientId,
    }),
  );
};

export const useGoalTrackQuery = () => {
  const clientId = useClientId();

  return useQuery(
    queryKeys.goalTrack(clientId),

    () => fetchGoalTrack({ clientId }),

    {
      cacheTime: 0,
    },
  );
};
